// src/index.ts
import { useCallback, useEffect, useRef } from "react";
function useCallbackRef(callback) {
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useCallback(function () {
    var _a;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, deps);
}
export { useCallbackRef };